import ImagePerson from "@/components/functionals/ImagePerson.vue";
import { formatDate } from "@/utils";
import formatterModulosRRHH from "@/components/functionals/formatterModulosRRHH.vue";
const permissionOrLinceseColumns = [
  {
    prop: "IdRequest",
    label: "ID",
    width: 125,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "NameEmployee",
    label: "Empleado",
    sortable: true,
    formatter: ImagePerson,
    width: 200,
    attrs: {
      imgKey: "PhotoEmployee"
    }
  },
  {
    prop: "CreatedAt",
    label: "Fecha Solicitud",
    width: 170,
    sortable: true,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.CreatedAt, "DD/MM/YYYY");
    }
  },
  // {
  //   prop: "Cedula",
  //   label: "Cedula",
  //   width: 125,
  //   sortable: true
  //   //formatter: HyperlinkForModuleVacations
  // },
  // {
  //   prop: "Department",
  //   label: "Departamento",
  //   width: 125,
  //   sortable: true
  //   //formatter: HyperlinkForModuleVacations
  // },
  // {
  //   prop: "Position",
  //   label: "Posicion",
  //   width: 125,
  //   sortable: true
  //   //formatter: HyperlinkForModuleVacations
  // },
  {
    prop: "NoDays",
    label: "# Dias",
    width: 125,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "NoHours",
    label: "# Horas",
    width: 125,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "StartDate",
    label: "Fecha Inicio",
    width: 200,
    sortable: true,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.StartDate, "DD/MM/YYYY HH:mm:ss");
    }
  },
  {
    prop: "FinishDate",
    label: "Fecha Fin",
    sortable: true,
    width: 200,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.FinishDate, "DD/MM/YYYY HH:mm:ss");
    }
  },
  // {
  //   prop: "Observations",
  //   label: "Observaciones",
  //   sortable: true,
  //   width: 125
  //   // formatter: HyperlinkForModuleVacations
  // },
  {
    prop: "SupervisorApproval",
    label: "Aprobacion Supervisor",
    sortable: true,
    width: 200,
    //value: true ?? false
    formatter: formatterModulosRRHH
  },
  {
    prop: "RRHH_Approval",
    label: "Aprobacion RRHH",
    sortable: true,
    width: 200,
    formatter: formatterModulosRRHH
    // formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Rejection_Comment",
    label: "Comentario de Rechazo",
    sortable: true,
    "min-width": 300
    // formatter: HyperlinkForModuleVacations
  }
];

const absenceColumns = [
  {
    prop: "IdRequest",
    label: "ID",
    width: 125,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "NameEmployee",
    label: "Empleado",
    sortable: true,
    formatter: ImagePerson,
    width: 200,
    attrs: {
      imgKey: "PhotoEmployee"
    }
  },
  {
    prop: "CreatedAt",
    label: "Fecha Solicitud",
    width: 170,
    sortable: true,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.CreatedAt, "DD/MM/YYYY");
    }
  },
  {
    prop: "NoDays",
    label: "# Dias",
    width: 125,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "NoHours",
    label: "# Horas",
    width: 125,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "StartDate",
    label: "Fecha Inicio",
    width: 200,
    sortable: true,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.StartDate, "DD/MM/YYYY HH:mm:ss");
    }
  },
  {
    prop: "FinishDate",
    label: "Fecha Fin",
    sortable: true,
    width: 200,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.FinishDate, "DD/MM/YYYY HH:mm:ss");
    }
  }
];

export { permissionOrLinceseColumns, absenceColumns };
